import { mergeInto } from '@/shared/utils';
import { present } from '@/shared/utils/typescript';
import FluidClient from '../client/FluidClient';
import Dossier from '../models/Dossier';
import DossierContext from '../models/DossierContext';
import Fluid, { FluidData } from '../models/Fluid';

class FluidService {
  async loadReplenished(dossier: Dossier): Promise<Array<Fluid>> {
    if (dossier.hasFluids) {
      return FluidClient.loadReplenished(dossier.id);
    } else {
      return [];
    }
  }

  async save(data: FluidData, fluid: Fluid, context: DossierContext): Promise<void> {
    const newFluid = await (fluid.isPresent() ? FluidClient.update(present(fluid.id), data) : FluidClient.create(data, fluid.typeId, context.dossier.id));
    mergeInto(newFluid, context.fluids, f => f.typeId === fluid.typeId);
  }

  async remove(fluid: Fluid): Promise<void> {
    await FluidClient.remove(present(fluid.id));
    fluid.clear();
  }
}

export default new FluidService();